<template>
  <svg id="ic_straighten" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <rect id="bound" width="32" height="32" fill="none" />
    <path
      id="path"
      d="M82.667-704a2.568,2.568,0,0,1-1.883-.783A2.568,2.568,0,0,1,80-706.667v-10.667a2.568,2.568,0,0,1,.783-1.883A2.568,2.568,0,0,1,82.667-720H104a2.568,2.568,0,0,1,1.883.783,2.568,2.568,0,0,1,.783,1.883v10.667a2.568,2.568,0,0,1-.783,1.883A2.568,2.568,0,0,1,104-704Zm0-2.667H104v-10.667h-4V-712H97.333v-5.333H94.667V-712H92v-5.333H89.333V-712H86.667v-5.333h-4Zm4-5.333h0ZM92-712h0Zm5.333,0h0ZM93.333-712Z"
      transform="translate(-77.333 728)"
      fill="#0c1b2a" />
  </svg>
</template>
